import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { ConfigurationService } from 'src/app/shared/configuration.service';


@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit, AfterViewInit, OnDestroy {

  private readonly windowObj: any;
  code = '';
  username: string;
  onPasswordSubmit: (code: string) => void;
  onChangePasswordSkipClick: () => void;
  errCode: string;


  @ViewChild('currentPasswordFormRef', { static: true }) currentPasswordFormRef: ElementRef;
  currentPasswordForm = new UntypedFormGroup(
    {
      currentPassword: new UntypedFormControl('', [Validators.required])
    },
    { updateOn: 'submit' }
  );

  @ViewChild('passwordInput') passwordInput: ElementRef<HTMLInputElement>;
  @ViewChild('continueBtn') continueBtn: ElementRef;
  formSubmitted = false;
  isInProgress = false;
  showNewPassword = true;
  passwordError = false;
  errorCode = '';
  passwordFormErrorAlert = false;
  userName = '';
  client: string | null;

  track = {
    changePasswordInputPageview: {
      pageView: true,
      isModalPopup: false,
      mappingKey: 'change-password-input',
    },
    changePasswordInputErrors: {
      pageView: false,
      isModalPopup: false,
      mappingKey: 'change-password-errors',
      category: 'self serve',
      type: '',
      code: '',
      API: this.configurationService.config.analyticsAPIUrl,
      field: ''
    },
    changePasswordInputFormError: {
      pageView: false,
      isModalPopup: false,
      mappingKey: 'change-password-errors',
      category: 'self serve',
      type: 'form',
      code: 'UE034',
      API: '',
      field: 'password'
    },
  };

  constructor(
    private readonly configurationService: ConfigurationService,
    private readonly translate: TranslateService,
    private readonly titleService: Title,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly cookieService: CookieService
  ) {
    this.windowObj = !!window.frameElement
      ? (window.parent as any)
      : (window as any);
  }

  ngOnInit(): void {

    this.client  = this.cookieService.get('client');
    this.userName = this.cookieService.get('username');
    let client = this.cookieService.get('brand');
    const brand = this.cookieService.get('client');

    if (brand === 'media'){
      client = 'media';
    }
    if (brand === 'media_dis'){
      client = 'media_dis';
    }

    var element = document.getElementById("transmitContainer");

    element.classList.add("hideTransmitContainer");

    let title = client + '.login.browserTitle';
    if (this.client === 'shaw' || this.client === 'shaw_direct' || this.client === 'shaw_enterprise'){
      title = client + '.login.title';
    };

    this.translate.onLangChange
    .pipe(untilDestroyed(this))
    .subscribe((langEvent: LangChangeEvent) => {
      this.titleService.setTitle(
        this.translate.instant(title)
      );
    });
    setTimeout(() => {
    this.titleService.setTitle(
      this.translate.instant(title)
    );
  }, 500);

}

validateAndSubmit(){
  if (this.code === '' || this.code === null) {
    this.passwordError = true;
  }
  else{
    this.passwordError = false;
  }
  if (this.passwordError) {
    return;
  }
  this.isInProgress = true;
  this.onPasswordSubmit(this.code);
}

keyDownEnter(event: any) {
  event.preventDefault();
  this.continueBtn.nativeElement.click();
}

ngAfterViewInit(): void {
  setTimeout(_ => {
    this.passwordInput.nativeElement.focus();
  }, 500);
}

onChangePasswordSkip(event) {
  event.preventDefault();
  this.onChangePasswordSkipClick();
}

setErrorCode(errorCode) {
  this.errorCode = errorCode;
  if (this.errorCode !== '' && this.errorCode !== undefined){
    const pwd = this.cookieService.get('errorPwdCode');

    this.currentPasswordForm.controls['currentPassword'].setValue(pwd);

    this.cookieService.delete('errorPwdCode');
    this.passwordFormErrorAlert = true;

   // this.continueBtn.nativeElement.click();
  }
  else{
    this.passwordFormErrorAlert = false;
  }

}

resetErrorCode() {
  this.passwordFormErrorAlert =  false;
}

ngOnDestroy(): void {}

}
